(function($) {

  // Adds data-date-format to all input date in a way to set the right date format to the inputs.
  // Docs: https://github.com/jcgertig/date-input-polyfill#features
  var inputElement = $('input[type="date"]').not('.js-flatpickr')
 
  $(inputElement).attr('data-date-format', 'dd/mm/yyyy');

})(jQuery);